import { isDefined } from '@e-socna/utils';
import { EMPTY_OBJECT } from '@e-socna/empty';

import type { DocumentEditorCmp_CustomLayout } from '../fragments/custom-layout.fragment';

export const removeNullsFromCustomLayout = (
  customLayout: Readonly<DocumentEditorCmp_CustomLayout>,
) => {
  const {
    orientation,
    paperFormat,
    hasPagebreakAfter,
    hasPagebreakBefore,
    ...rest
  } = customLayout;

  return {
    ...rest,
    ...(isDefined(orientation) ? { orientation } : EMPTY_OBJECT),
    ...(isDefined(paperFormat) ? { paperFormat } : EMPTY_OBJECT),
    ...(isDefined(hasPagebreakAfter) ? { hasPagebreakAfter } : EMPTY_OBJECT),
    ...(isDefined(hasPagebreakBefore) ? { hasPagebreakBefore } : EMPTY_OBJECT),
  } as typeof customLayout;
};
